import {combineReducers} from 'redux';
import auth from './auth';
import system from './system';
import inventory from './inventory';
import warehouse from './warehouse';
import relation from './relation';
import address from './address';
import contact from './contact';
import pricing from './pricing';
import order from './orders';
import shipment from './shipment';
import user from './user';
import returnStore from './return';
import integrations from './integrations';
import qb from './qb';
import ecommerce from './ecommerce';

export default combineReducers({
    auth, system, inventory, warehouse, relation, address, contact, pricing, order, shipment, user,
    returnStore:returnStore, integrations, qb, ecommerce
})


// WEBPACK FOOTER //
// ./src/stores/rootReducer.js